import { Headers, Http, Response } from '@angular/http';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';
import { Cookie } from '../../utils/cookie';
import { TmErrorInfo } from '../model/error';

export class ApiBase {
    private _http: Http;

    protected readonly cachebleHeaders: Headers = new Headers({
        'Content-Type': 'application/json',
        currentdatetime: new Cookie().CurrentDate,
    });
    protected readonly headers: Headers = new Headers({
        'Content-Type': 'application/json',
        'cache-control': 'no-cache',
        currentdatetime: new Cookie().CurrentDate,
    });
    protected readonly postHeaders: Headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
        'cache-control': 'no-cache',
        currentdatetime: new Cookie().CurrentDate,
    });
    protected tokenUrl = '/api/token';
    protected baseUrl: string;
    protected baseUrlv3: string;

    protected language: string;
    protected cartGuid: string;
    protected customerEdp: number;
    protected userToken: string;

    constructor(protected http: Http) {
        let cookie = new Cookie();

        this.language = cookie.ApiLanguage;
        this.cartGuid = cookie.CartGuid;
        this.baseUrl = '/api/v2/' + this.language;
        this.baseUrlv3 = '/api/v3/' + this.language;
        if (
            cookie.UserAccessToken != undefined &&
            cookie.UserAccessToken.Edp != undefined &&
            cookie.UserAccessToken.Edp > 0
        ) {
            this.customerEdp = cookie.UserAccessToken.Edp;
        }
        if (
            cookie.UserAccessToken != undefined &&
            cookie.UserAccessToken.Token != undefined &&
            cookie.UserAccessToken.Token != ''
        ) {
            this.userToken = cookie.UserAccessToken.Token;
        }
    }

    get userTokenJsonTypeHeader(): Headers {
        let getheader = this.headers;

        getheader.delete('Authorization');
        getheader.append('Authorization', 'Bearer ' + this.userToken);

        return getheader;
    }

    get userTokenEncodedTypeHeader(): Headers {
        let postheader = this.postHeaders;

        postheader.delete('Authorization');
        postheader.append('Authorization', 'Bearer ' + this.userToken);

        return postheader;
    }

    get appTokenJsonTypeHeader(): Headers {
        let getheader = this.headers;
        let appToken = new Cookie().AppToken;
        this.getAppToken().map((tokenResp) => {
            appToken = tokenResp;
        });
        getheader.delete('Authorization');
        getheader.append('Authorization', 'Bearer ' + appToken);

        return getheader;
    }

    get appTokenEncodedTypeHeader(): Headers {
        let postheader = this.postHeaders;
        let appToken = new Cookie().AppToken;
        this.getAppToken().map((tokenResp) => {
            appToken = tokenResp;
        });

        postheader.delete('Authorization');
        postheader.append('Authorization', 'Bearer ' + appToken);

        return postheader;
    }

    protected createAppToken(): Observable<any> {
        let body =
            'userName=' + (<any>window).appUserName + '&password=' + (<any>window).appPassword + '&grant_type=password';
        return this.http.post(this.tokenUrl, body, { headers: this.postHeaders });
    }

    protected getAppToken(): Observable<string> {
        let cookie = new Cookie();
        if (cookie.AppToken === undefined) {
            return this.createAppToken().map((resp) => {
                cookie.AppToken = resp.json().access_token;
                return cookie.AppToken;
            });
        } else {
            return Observable.of(cookie.AppToken).map((accessToken) => accessToken);
        }
    }

    protected handleError(error: Response) {
        if (error.status === 401) {
            let cookie = new Cookie();
            cookie.TargetUrl = window.location.href;
            cookie.deleteUserToken();
            cookie.deleteUserEmail();
            cookie.deleteUserName();
            cookie.deleteLastName();
            window.location.href = '/pages/signin';
        } else if (error.status === 417) {
            let errorInfo: TmErrorInfo = (error.json() as TmErrorInfo[])[0];
            return Observable.throw(errorInfo.Message);
        } else {
            return Observable.throw(error.json());
        }
    }
    protected handleErrorWithDetails(error: Response) {
        if (error.status === 401) {
            let cookie = new Cookie();
            cookie.TargetUrl = window.location.href;
            cookie.deleteUserToken();
            cookie.deleteUserEmail();
            cookie.deleteUserName();
            cookie.deleteLastName();
            window.location.href = '/pages/signin';
        } else if (error.status === 417) {
            let errorInfo: TmErrorInfo = (error.json() as TmErrorInfo[])[0];
            return Observable.throw(errorInfo);
        } else {
            return Observable.throw(error.json());
        }
    }

    public handleAuthorizationFailure() {
        let cookie = new Cookie();
        cookie.TargetUrl = window.location.href;
        cookie.deleteUserToken();
        cookie.deleteUserEmail();
        cookie.deleteUserName();
        cookie.deleteLastName();
        window.location.href = '/pages/signin';
    }

    protected getProvinceCode(prvName: string) {
        var prvCode = 'ON';
        switch (prvName.toLowerCase()) {
            case 'alberta':
            case 'ab':
                prvCode = 'AB';
                break;
            case 'british columbia':
            case 'bc':
                prvCode = 'BC';
                break;
            case 'manitoba':
            case 'mb':
                prvCode = 'MB';
                break;
            case 'new brunswick':
            case 'nb':
                prvCode = 'NB';
                break;
            case 'newfoundland and labrador':
            case 'nl':
                prvCode = 'NL';
                break;
            case 'northwest territories':
            case 'nt':
                prvCode = 'NT';
                break;
            case 'nova scotia':
            case 'ns':
                prvCode = 'NS';
                break;
            case 'nunavut':
            case 'nu':
                prvCode = 'NU';
                break;
            case 'ontario':
            case 'on':
                prvCode = 'ON';
                break;
            case 'prince edward island':
            case 'pe':
                prvCode = 'PE';
                break;
            case 'quebec':
            case 'qc':
                prvCode = 'QC';
                break;
            case 'saskatchewan':
            case 'sk':
                prvCode = 'SK';
                break;
            case 'yukon':
            case 'yt':
                prvCode = 'YT';
                break;
            default:
                prvCode = 'ON';
                break;
        }
        return prvCode;
    }
}



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/apibase.service.ts